/** Native scroll only. Lenis was hiding sections and stalling first paint. */
export default function SmoothScroll() {
  return null;
}
